export const menu = [
    {
        name: 'header.nav.dashboard',
        route: '/dashboard',
    },
];
